import { render, staticRenderFns } from "./IpsTagInput.vue?vue&type=template&id=a9507ec0&scoped=true"
import script from "./IpsTagInput.vue?vue&type=script&lang=js"
export * from "./IpsTagInput.vue?vue&type=script&lang=js"
import style0 from "./IpsTagInput.vue?vue&type=style&index=0&id=a9507ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9507ec0",
  null
  
)

export default component.exports